import { cn } from '../../lib/utils';
import { Avatar } from '../Avatar';
import { Tooltip } from '../Tooltip';
import Color from 'color';
import type { StringAvatarProps } from './types';

const getInitials = (text?: string): string => {
  if (!text) return '';
  const parts = text.toUpperCase().split(' ').filter(Boolean);
  return parts.length > 1
    ? `${parts[0][0]}${parts[parts.length - 1][0]}`
    : parts[0][0];
};

function StringAvatar({
  text,
  bgColor,
  showTooltip = false,
  small = false,
  avatarSize = 26,
  icon = null,
}: StringAvatarProps) {
  const avatarClasses = cn(
    small ? 'eye:tag' : 'eye:button',
    Color(bgColor).isDark() ? 'eye:[&]:text-white' : 'eye:[&]:text-black',
  );

  const avatarContent = (
    <Avatar
      className={avatarClasses}
      style={{
        backgroundColor: bgColor,
        width: avatarSize,
        height: avatarSize,
      }}
      alt={text}
    >
      {icon || getInitials(text)}
    </Avatar>
  );

  return showTooltip ? (
    <Tooltip content={text}>{avatarContent}</Tooltip>
  ) : (
    avatarContent
  );
}

export { StringAvatar };
